var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

/*
  This is a top-level Controllers library. This library loads all other
  controller libraries.
*/
var TimerControllers = require('./timer-controller');

var Controllers = /*#__PURE__*/function () {
  "use strict";

  function Controllers() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Controllers);

    // Dependency Injection
    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Instance of adapters required when instantiating Controllers');
    } // Encapsulate dependencies


    this.timer = new TimerControllers(localConfig);
  }

  return _createClass(Controllers);
}();

module.exports = Controllers;